import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation putTreeEditorData(
    $tenantId: ID!
    $zoneId: ID!
    $insertion: DataInsertion!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        putData(insertion: $insertion)
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.always(undefined)

export const executor = graphql.createExecutor<
  graphql.schema.PutTreeEditorDataMutation,
  undefined,
  graphql.schema.PutTreeEditorDataMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
